import dayjs from "dayjs";
import { DEFAULT_DATA_FORMAT } from "../constants/constant";
import { EditColumnType, IFieldInfo } from "./interface";
import { ITotalItem } from "../SuperTable/subpage/tableTotal";
import { accAdd } from "../utils/dataUtils";

/**
 * 提取列配置中的字段信息
 * @param columns 列配置
 * @isChildren 是否为子表数据
 * @returns 
 */
export function getFieldInfo(columns?: EditColumnType[]): IFieldInfo {
  const fieldInfo: IFieldInfo = { date: {}, subFields: [], };
  if (Array.isArray(columns)) {
    columns.forEach(item => {
      const { dataIndex, formItemType, datePickerProps, children, isRowSpan } = item;
      if (Array.isArray(children)) {
        const childrenResult = getFieldInfo(children);
        fieldInfo.date = Object.assign(fieldInfo.date, childrenResult.date);
        fieldInfo.subFields?.push(...(childrenResult.subFields ?? []));
        return;
      }
      if (!isRowSpan) {
        if (Array.isArray(dataIndex)) {
          fieldInfo.subFields?.push(...dataIndex);
        } else {
          fieldInfo.subFields?.push(dataIndex as string);
        }
      }
      if (formItemType === 'DatePicker' && typeof dataIndex === 'string') {
        const datePickerFormat = datePickerProps?.format;
        fieldInfo.date[dataIndex] = typeof datePickerFormat === 'string' ? datePickerFormat : DEFAULT_DATA_FORMAT;
      }
    });
  }
  return fieldInfo;
}
/**
 * 格式化表单数据的日期
 * @param formData 表单数据
 * @param dateNames 日期格式化配置
 * @param filterEmptyValue 是否过滤空值
 * @param isSubField 是否取子表数据
 * @param isReduction 是否移除内部添加数据
 * @returns 
 */
export function formatFormData(
  formData: any,
  fieldInfo: IFieldInfo,
  filterEmptyValue: boolean = false,
  isSubField: boolean = true,
  isReduction: boolean = true,
) {
  const result: any = {};
  if (!formData) {
    return result;
  }
  const { date, subFields, } = fieldInfo;
  for (let [key, value] of Object.entries(formData)) {
    if (filterEmptyValue && (value === undefined || value === null)) {
      continue;
    }
    if (isReduction && key === 'key') {
      continue;
    }
    if (isSubField) {
      if (subFields?.includes(key)) {
        if (date[key] && dayjs.isDayjs(value)) {
          result[key] = value.format(date[key]);
        } else {
          result[key] = value;
        }
      }
    } else {
      if (!subFields?.includes(key)) {
        if (date[key] && dayjs.isDayjs(value)) {
          result[key] = value.format(date[key]);
        } else {
          result[key] = value;
        }
      }
    }
  }
  return result;
}
/**
 * 生成统计数据
 * @param totalKeys 统计字段配置
 * @param dataSource 可编辑表数据
 * @returns 
 */
export function getTotalInfo(
  totalKeys?: ITotalItem[],
  dataSource?: any[],
): any {
  let totalData: any = {};
  if (Array.isArray(totalKeys) && Array.isArray(dataSource)) {
    totalKeys.forEach(item => {
      const { dataIndex, format } = item;
      const currentValue = dataIndexTotal(dataIndex, dataSource);
      totalData[dataIndex] = format ? format(currentValue) : currentValue;
    });
  }
  return totalData;
}
/**
 * 根据字段名求和
 * @param dataIndex 字段名
 * @param dataSource 可编辑表数据
 * @returns 
 */
export function dataIndexTotal(dataIndex: string, dataSource: any[]): number {
  let total: number = 0;
  dataSource.forEach(item => {
    const children = item.children;
    if (Array.isArray(children)) {
      const childrenTotal = dataIndexTotal(dataIndex, children);
      total = accAdd(total, childrenTotal);
    }
    if (item[dataIndex]) {
      total = accAdd(total, Number(item[dataIndex]) || 0);
    }
  });
  return total;
}